import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation.js";
import {
  BACK_ROW,
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_ROW,
  VALUE_FILL,
  hideColumnsAfter,
  setCell,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  addSheetTitle,
  addTableSpacer,
  applyBorderPattern,
  outerRowPatterns,
  setupPrinciple2DetailSheet,
  writeDataRow,
} from "./principle2DetailHelpers.js";
import { safeText } from "./principle6SheetHelpers.js";

export const SHEET_NAME = "Initiative to improve resource";

const SHEET_TITLE =
  "If the entity has undertaken any specific initiatives or used innovative technology or solutions to improve resource efficiency, or reduce impact due to emissions / effluent discharge / waste generated, please provide details of the same as well as outcome of such initiatives";

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 6.26953125,
  E: 55.7265625,
  F: 43.54296875,
  G: 43.453125,
  H: 35.453125,
  I: 9.1796875,
  J: 9.1796875,
  K: 9.1796875,
  L: 9.1796875,
};

const TEMPLATE_ROW = 10;
const SPACER_ROW = 11;
const DATA_START_ROW = 12;
const COL_END = COL_H;

const ALL_THIN = Array(5).fill("tttt");
const SPACER_BORDERS = outerRowPatterns(COL_D, COL_END);

function initiativeDetails(item) {
  const detail = safeText(item?.detail, "");
  const link = safeText(item?.webLink, "");
  if (detail && link && detail !== "-" && link !== "-") return `${detail}\n${link}`.trim();
  if (detail && detail !== "-") return detail;
  if (link && link !== "-") return link;
  return "";
}

export function buildInitiativeToImproveResourceSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd: COL_END,
    ySplit: 11,
    topLeftCell: "D12",
    hiddenCols: ["A", "B"],
  });
  hideColumnsAfter(ws, 11);

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_6, {
    row: BACK_ROW,
    col: COL_END,
    mergeEnd: COL_END,
    align: "right",
    parentCell: "D8",
  });

  addSheetTitle(ws, COL_END, SHEET_TITLE, {
    height: 35.25,
    borderPatterns: outerRowPatterns(COL_D, COL_END),
  });

  applyBorderPattern(ws, HEADER_ROW, COL_D, ALL_THIN);
  ws.getRow(HEADER_ROW).height = 29;
  [
    { col: COL_D, label: "Sr. No." },
    { col: COL_E, label: "Initiative undertaken" },
    {
      col: COL_F,
      label:
        "Details of the initiative (Web-link, if any, may be provided along-with summary)",
    },
    { col: COL_G, label: "Outcome of the initiative" },
    { col: COL_H, label: "Corrective action taken, if any" },
  ].forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      font: HEADER_FONT_11,
      bold: false,
      bordered: false,
      align: "center",
    });
  });

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, ALL_THIN);
  for (let col = COL_D; col <= COL_END; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", { bordered: false, font: BODY_FONT });
  }
  ws.getRow(TEMPLATE_ROW).height = 58;
  ws.getRow(TEMPLATE_ROW).hidden = true;

  addTableSpacer(ws, COL_D, COL_END, { row: SPACER_ROW, height: 30, patterns: SPACER_BORDERS });

  const rows = sectionC?.principle6?.leadershipIndicator?.spcificIntiativesorUsedInnovative || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(
      ws,
      row,
      COL_D,
      COL_END,
      [
        { col: COL_D, value: idx + 1, align: "center", fill: null, font: BODY_FONT },
        {
          col: COL_E,
          value: safeText(item?.intiativeundertaken, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_F,
          value: initiativeDetails(item),
          align: "left",
          fill: VALUE_FILL,
          vertical: "top",
        },
        {
          col: COL_G,
          value: safeText(item?.outCome, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_H,
          value: safeText(item?.correctiveAction ?? item?.corrective, ""),
          align: "left",
          fill: VALUE_FILL,
        },
      ],
      { patterns: ALL_THIN }
    );
  });

  return ws;
}
